<template>
  <div class="recursos-prazos">
    <div class="coming-soon">
      <i class="fas fa-calendar-alt"></i>
      <h2>Prazos de Recursos</h2>
      <p>Esta funcionalidade está sendo implementada.</p>
      <button class="btn btn-secondary" @click="voltar">
        <i class="fas fa-arrow-left"></i>
        Voltar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecursosPrazos',
  methods: {
    voltar() {
      this.$router.push({ name: 'admin-recursos' })
    }
  }
}
</script>

<style lang="scss" scoped>
.recursos-prazos {
  .coming-soon {
    background: white;
    border-radius: 15px;
    padding: 60px 30px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);

    i {
      font-size: 64px;
      color: #667eea;
      margin-bottom: 20px;
    }

    h2 {
      margin: 0 0 15px 0;
      color: #2c3e50;
    }

    p {
      margin: 0;
      color: #6c757d;
    }

    .btn {
      margin-top: 20px;
      border: none;
      border-radius: 8px;
      padding: 10px 16px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 8px;

      &.btn-secondary {
        background: #6c757d;
        color: white;
      }
    }
  }
}
</style>
